import { useIndexStore } from '~/store';
import { breakDownHostUrl } from './utils';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/vue';
import { setLoginInfoInApp } from '~/frontend-shared/helper/login-util';
//设置用户相关信息
export function setAppLoginInfo(vueInstance: any, resData: any) {
  // TODO 3619
  console.log('setAppLoginInfo==', vueInstance, resData);
  const store = useIndexStore();
  store.SET_USER(resData.loginName);
  // store.SET_TOKEN(resData.accessToken);
  store.SET_SALT(resData.accessSalt);
  setLoginInfoInApp(resData);
}

// 语言配置
const I18nDict = new Map([
  ['cn', 'zh_CN'],
  ['zh-CN', 'zh_CN'],

  ['jp', 'ja_JP'],
  ['ja-JP', 'ja_JP'],

  ['kr', 'ko_KR'],
  ['ko-KR', 'ko_KR'],

  ['vn', 'vi_VN'],
  ['vi-VN', 'vi_VN'],

  ['ru', 'ru_RU'],
  ['ru-RU', 'ru_RU'],

  ['zh-TW', 'zh_TW'],

  ['tr', 'tr_TR'],
  ['tr-TR', 'tr_TR'],

  ['es', 'es_ES'],
  ['es-ES', 'es_ES'],

  ['br', 'pt_BR'],
  ['pt-BR', 'pt_BR'],
]);

// 正常转化
export const transLang = (lang: string) => {
  const store = useIndexStore();
  const { localeConfigList } = store;
  const currLocaleInfo = localeConfigList?.find((item: any) => item.locale === lang);
  // 这里只保留小写的映射
  if (I18nDict.has(lang)) {
    return I18nDict.get(lang);
  } else {
    return currLocaleInfo?.localeWithUnderLine || 'en_US';
  }
};
